export class RememberMeToken {

  constructor(
    public value: string,
    public client?: string) {
  }
}
